<template>
  <div class="lg:px-33 md:px-33 sm:px-0 h-full">
    <div
      v-show="step === 'register'"
      class="flex flex-col-reverse sm:flex-col w-full h-auto md:h-full"
    >
      <div class="flex flex-col md:flex-row px-6 lg:px-0 justify-center h-full">
        <register-form
          @set-registration-detail="setRegistrationDetail($event)"
          @registered="handleRegistered($event)"
          @next-step="step = 'firm'"
          class="w-full md:w-6/12"
        />
        <register-info class="w-full hidden md:flex md:w-6/12" />
      </div>
    </div>
    <div
      v-show="step === 'firm'"
      class="flex flex-col-reverse sm:flex-col w-full h-auto md:h-full"
    >
      <div class="flex flex-col md:flex-row px-6 lg:px-0 justify-center h-full">
        <firm-info
          @set-registration-detail="setRegistrationDetail($event)"
          @submit="submit"
          class="w-full md:w-6/12"
          @back="step = 'register'"
          :initial-company-name="registrationDetails.company_name"
          @update:company-name="firmName = $event"
        />
        <firm-info-graphic
          :firm-name="firmName"
          class="w-full hidden md:block md:w-6/12"
        />
      </div>
    </div>

    <div
      v-show="step === 'onboard'"
      class="flex w-full h-full"
    >
      <onboarding-slides-stepper @onboarding-complete="handleOnboardingComplete" />
    </div>
  </div>
</template>

<script>
import RegisterForm from "../components/RegisterForm.vue"
import RegisterInfo from "../components/RegisterInfo.vue"
import FirmInfo from "../components/RegistrationStep/FirmInfo.vue"
import FirmInfoGraphic from "../components/RegistrationStep/FirmInfoGraphic.vue"
import OnboardingSlidesStepper from "../components/OnboardingSlidesStepper/OnboardingSlidesStepper.vue"
import EventAnalytics from "../../helpers/EventAnalytics"

const EXPERIMENT_FLAG_KEY = "onboarding_slides"
const VARIANT_SLIDES = "Slides"
const VARIANT_NO_SLIDES = "No Slides"
const VALID_VARIANTS = [VARIANT_SLIDES, VARIANT_NO_SLIDES]

export default {
  name: "Registration",

  components: {
    RegisterForm,
    RegisterInfo,
    FirmInfo,
    FirmInfoGraphic,
    OnboardingSlidesStepper,
  },

  data() {
    return {
      registrationDetails: {},
      redirect_url: "",
      step: "register",
      firmName: "",
      userId: null,
      variant: VARIANT_NO_SLIDES,
    }
  },

  methods: {
    setRegistrationDetail(event) {
      Object.assign(this.registrationDetails, event)
    },

    handleRegistered({ redirect_url, company_name, user_id }) {
      if (redirect_url) {
        this.redirect_url = redirect_url
      }
      if (company_name) {
        this.registrationDetails.company_name = company_name
      }
      if (user_id) {
        this.userId = user_id
        EventAnalytics.init({ userId: user_id })
      }
    },

    sendRegisterEventToGoogle() {
      try {
        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({
          event: "free_trial_signup",
        })

        const is_not_icp = ["Just me", "2 to 4"].includes(this.registrationDetails.firm_size)
        if (!is_not_icp) {
          window.dataLayer.push({
            event: "icp_signup",
          })
        }
      } catch (e) {
        // ignore error
        console.error(e)
      }
    },

    async resolveVariant() {
      const env = window.FinancialCents?.env
      if (env !== "production") {
        const params = new URLSearchParams(window.location.search)
        const forced = params.get("onboarding_variant")
        if (forced && VALID_VARIANTS.includes(forced)) {
          return forced
        }
      }

      const resolved = await EventAnalytics.getVariant(EXPERIMENT_FLAG_KEY, VARIANT_NO_SLIDES)
      return VALID_VARIANTS.includes(resolved) ? resolved : VARIANT_NO_SLIDES
    },

    async submit() {
      this.sendRegisterEventToGoogle()

      // Special signup flows (invitation acceptance, template sharing) send a non-/home
      // redirect_url. Skip the A/B test entirely — those signups have a deterministic destination.
      if (this.redirect_url && this.redirect_url !== "/home") {
        window.location.href = this.redirect_url
        return
      }

      this.variant = await this.resolveVariant()

      EventAnalytics.registerSuperProperty("onboarding_variant", this.variant)
      EventAnalytics.track("Onboarding Variant Assigned", { variant: this.variant })

      if (this.variant === VARIANT_SLIDES) {
        this.step = "onboard"
        return
      }

      window.location.href = "/home?onboarding=1"
    },

    handleOnboardingComplete() {
      window.location.href = "/home?onboarding=1"
    },
  },
}
</script>
